import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useBlog } from '../../context/BlogContext';
import { formatBlogDateTime } from '../../utils/blog';

export default function AdminBlogPosts() {
  const { posts, isLoading, error, refreshPosts, deletePost } = useBlog();

  useEffect(() => {
    void refreshPosts({ silent: posts.length > 0, admin: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPosts]);

  const handleDelete = async (id: number, title: string) => {
    if (!confirm(`"${title}" yazısını silmek istediğinize emin misiniz?`)) return;

    try {
      await deletePost(id);
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Blog yazısı silinemedi.');
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Blog</h1>
          <p>Site blog yazılarını yönetin</p>
        </div>
        <Link to="/admin/blog/new" className="btn btn-primary">
          + Yeni Yazı
        </Link>
      </div>

      {error && (
        <div className="auth-error">
          {error}
          <button
            type="button"
            className="btn btn-outline btn-sm"
            onClick={() => void refreshPosts({ admin: true })}
          >
            Tekrar Dene
          </button>
        </div>
      )}

      {isLoading ? (
        <p>Yükleniyor...</p>
      ) : posts.length === 0 ? (
        <div className="admin-empty">
          <p>Henüz blog yazısı yok.</p>
          <Link to="/admin/blog/new" className="btn btn-primary">
            İlk Yazıyı Ekle
          </Link>
        </div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Başlık</th>
                <th>Durum</th>
                <th>Yayın</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id}>
                  <td>
                    <div>
                      <strong>{post.title}</strong>
                      <span className="admin-order-meta">/{post.slug}</span>
                    </div>
                  </td>
                  <td>
                    <span className={`admin-badge ${post.isPublished ? 'in-stock' : 'out-stock'}`}>
                      {post.isPublished ? 'Yayında' : 'Taslak'}
                    </span>
                  </td>
                  <td>{formatBlogDateTime(post.publishedAt ?? post.updatedAt)}</td>
                  <td>
                    <div className="admin-actions">
                      {post.isPublished && (
                        <Link to={`/blog/${post.slug}`} className="btn btn-outline btn-sm" target="_blank">
                          Görüntüle
                        </Link>
                      )}
                      <Link to={`/admin/blog/${post.id}/edit`} className="btn btn-outline btn-sm">
                        Düzenle
                      </Link>
                      <button
                        type="button"
                        className="btn btn-outline btn-sm admin-btn-danger"
                        onClick={() => void handleDelete(post.id, post.title)}
                      >
                        Sil
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
